import ChartBase from "./ChartBase";
export class Table extends ChartBase {
    constructor() {
        super();
        this._init = () => {
            // always call this
            this._getElements();
            // get survey name element
            this.theadElement = this.wrapper.querySelector("thead");
            this.tbodyElement = this.wrapper.querySelector("tbody");
        };
        this.updateData = (props) => {
            // get correct props
            var correctProps = props;
            // test combined props
            if (props.tableData) {
                correctProps = props.tableData;
            }
            //set metric and question
            this._setBaseInfo(props);
            // get data and labels
            const { header, body, total } = correctProps;
            // header
            this.theadElement.innerHTML = "";
            this.theadElement.appendChild(this._createTrHeader(header));
            // body
            this.tbodyElement.innerHTML = "";
            if (body) {
                body.forEach(row => {
                    this.tbodyElement.appendChild(this._createTr(row));
                });
            }
            // total
            if (!this.noTotal) {
                if (total && total.length > 0) {
                    const totalRow = this._createTr(total);
                    totalRow.className = "tr-total";
                    this.tbodyElement.appendChild(totalRow);
                }
            }
            // remove loading
            this.loading = false;
        };
        this._createTrHeader = (data) => {
            const tr = document.createElement("tr");
            if (data) {
                data.forEach(item => {
                    const td = document.createElement("th");
                    td.textContent = item;
                    tr.appendChild(td);
                });
            }
            return tr;
        };
        this._createTr = (data) => {
            const tr = document.createElement("tr");
            if (data) {
                data.forEach(item => {
                    const td = document.createElement("td");
                    td.textContent = item;
                    tr.appendChild(td);
                });
            }
            return tr;
        };
    }
    get noTotal() {
        return this.hasAttribute("no-total");
    }
    connectedCallback() {
        // html template
        this.innerHTML = `
                        <div class="${this.class} dashboard-charts-item" data-wrapper>
                            <div class="d-flex align-items-center mb-3">
                                <h6 class="text-uppercase font-weight-bold mb-0" data-metric></h6>
                    ${!!this.chartName ? `<div class="dashboard-charts-name">${this.chartName}</div>` : ''}
                            </div>
                            <p class="text-muted-light font-italic dashboard-charts-item-question" data-question></p>
                            <div class="table-responsive">
                                <table class="table dashboard-charts-table mb-0">
                                    <thead>
                                    </thead>
                                    <tbody>
                                    </tbody>
                                </table>
                            </div>
                        </div>
        `;
        this._init();
    }
}
window.customElements.define("sva-table", Table);
